const Dashboard = {
    dashboard: () => "admin/dashboard",
}

export default Dashboard
